import downLoadItem from "@/components/Layout/downLoad-item.vue";
import Android from "@/assets/download/Android.webp";
import Ios from "@/assets/download/Ios.webp";
import Harmony from "@/assets/download/harmony.webp";
export default {
  name: "download-center",
  components: {
    downLoadItem
  },
  data() {
    return {
      downCenterLinkList: [{
        name: "Android",
        link: "https://emas-devops-cdn.aliyuncs.com/job/PJ723574773468333056/greencloud@7.6.60.1-release-64.apk",
        img: Android,
        text: "Android"
      }, {
        name: "IOS",
        link: "https://apps.apple.com/us/app/%E6%95%B0%E6%99%BA%E5%8A%A9%E6%89%8B/id1670027670",
        img: Ios,
        text: "IOS"
      }, {
        name: "Harmony",
        link: "https://appgallery.huawei.com/app/detail?id=com.dingtalk.hmos.greencloud",
        img: Harmony,
        text: "Harmony"
      }]
    };
  }
};